import styled from "styled-components";

const PaxItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 22px;
  background: none;
  width: 100%;
  text-align: left;
  border: 1px solid ${({ theme }) => theme.colors.base2};
  border-radius: ${({ theme }) => theme.borderRadiusChecklistCard};
  outline: none;
  cursor: pointer;

  &:not(:first-child) {
    margin-top: 16px;
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.primary1};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.base1};
  }

  img {
    margin-right: 22px;
  }
`;

export default PaxItem;
